import { Capacitor } from "@capacitor/core";

const ZUNO_FIREBASE_PROJECT_ID = "zuno-novo";
const ZUNO_FIREBASE_PROJECT_NUMBER = "45715761779";
const NATIVE_PLATFORMS = new Set(["ios", "android"]);

const requiredValue = (env, name) => {
  const value = String(env[name] || "").trim();
  if (!value) throw new Error(`Zuno Firebase configuration is missing ${name}.`);
  return value;
};

export function resolveFirebaseClientConfig({
  env = process.env,
  native = Capacitor.isNativePlatform(),
  platform = Capacitor.getPlatform?.() || "web",
} = {}) {
  const runtimePlatform = native ? platform : "web";
  const buildPlatform = String(env.REACT_APP_FIREBASE_NATIVE_PLATFORM || "web").trim().toLowerCase();
  const keyRole = String(env.REACT_APP_FIREBASE_KEY_ROLE || buildPlatform).trim().toLowerCase();

  if (runtimePlatform !== "web" && !NATIVE_PLATFORMS.has(runtimePlatform)) {
    throw new Error(`Unsupported native Firebase platform: ${runtimePlatform}.`);
  }
  if (buildPlatform !== runtimePlatform) {
    throw new Error(`Zuno Firebase platform mismatch: ${runtimePlatform} runtime received ${buildPlatform} configuration.`);
  }
  if (keyRole !== runtimePlatform) {
    throw new Error(`Zuno Firebase key-role mismatch: ${runtimePlatform} runtime received ${keyRole} credentials.`);
  }

  const projectId = requiredValue(env, "REACT_APP_FIREBASE_PROJECT_ID");
  const messagingSenderId = requiredValue(env, "REACT_APP_FIREBASE_MESSAGING_SENDER_ID");
  if (projectId !== ZUNO_FIREBASE_PROJECT_ID || messagingSenderId !== ZUNO_FIREBASE_PROJECT_NUMBER) {
    throw new Error("Zuno Firebase configuration is not associated with the production project.");
  }

  return {
    buildPlatform,
    runtimePlatform,
    config: {
      apiKey: requiredValue(env, "REACT_APP_FIREBASE_API_KEY"),
      authDomain: requiredValue(env, "REACT_APP_FIREBASE_AUTH_DOMAIN"),
      projectId,
      storageBucket: requiredValue(env, "REACT_APP_FIREBASE_STORAGE_BUCKET"),
      messagingSenderId,
      appId: requiredValue(env, "REACT_APP_FIREBASE_APP_ID"),
      measurementId: String(env.REACT_APP_FIREBASE_MEASUREMENT_ID || "").trim() || undefined,
      databaseURL: requiredValue(env, "REACT_APP_FIREBASE_DATABASE_URL"),
    },
  };
}

export const firebaseClientConfigConstants = Object.freeze({
  projectId: ZUNO_FIREBASE_PROJECT_ID,
  projectNumber: ZUNO_FIREBASE_PROJECT_NUMBER,
  nativePlatforms: [...NATIVE_PLATFORMS],
});
